export default __webpack_public_path__ + "static/media/style-icon.3200c5b0.svg";